import { Input } from '@unified-checkout/design-system';
import { MagnifyingGlass } from '@unified-checkout/design-system/icons/index';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackButton } from 'apps/customer/src/components';
import { QuestionsElements } from './QuestionsElements';
import { CurrentFaq } from './CurrentFaq';

export const FAQs = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const searchParams = new URLSearchParams(useLocation().search);

  const currentFaq = searchParams.get('faq');

  if (currentFaq) {
    return <CurrentFaq currentFaq={currentFaq} />;
  }

  return (
    <section>
      <BackButton onClick={() => navigate(-1)} />
      <h2 className="!mb-3 md:!mb-8 page-title">Frequently asked questions</h2>
      <div className="[&_path]:fill-gray-500">
        <Input
          onChange={(e) => setSearchTerm(e.target.value)}
          name="search faqs"
          leadingIcon={MagnifyingGlass}
          placeholder="Search by keywords..."
        />
      </div>
      <section className="px-2 pt-2 pb-5 space-y-6 bg-white divide-y divide-gray-200 md:px-6 ">
        <QuestionsElements searchTerm={searchTerm} />
      </section>
    </section>
  );
};
